// src/pages/Callback.tsx
import { useEffect } from "react";

const MsalRedirectPage = () => {
  // useEffect(() => {
  //   // Simple redirect to home page - App.js will handle the authentication
  //   window.location.href = '/';
  // }, []);

  return null; // No custom UI, just redirect
};

export default MsalRedirectPage;
